<div class="filing-form-container">
  <app-filing-loader-outlet></app-filing-loader-outlet>
  <p-toast></p-toast>
  <p-confirmDialog></p-confirmDialog>

  <!-- Hidden file input for import -->
  <input
    type="file"
    id="importFileInput"
    accept=".json"
    (change)="importData($event)"
    style="display: none;"
  />

  <div class="mb-10 flex gap-4 xlplus:gap-6 items-center mx-[24px] text-[22px] xlplus:text-2xl font-semibold mt-5">
    <svg
      class="w-[10px] h-[18px] xlplus:w-[14px] xlplus:h-[22px] cursor-pointer"
      viewBox="0 0 10 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      (click)="goBack()"
    >
      <path
        d="M9.8002 2.99961L3.8002 8.99961L9.8002 14.9996L8.6002 17.3996L0.200195 8.99961L8.6002 0.599609L9.8002 2.99961Z"
        fill="black"
      />
    </svg>
    {{ companyName() | titlecase }}
  </div>

  <!-- Info banner -->
  <div class="mb-6">
    <p-message
      severity="info"
      class="w-full">
      <div class="flex items-start gap-2">
          <!-- custom SVG icon -->
          <svg width="14" height="34" viewBox="0 0 14 34" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7 2C3.13428 2 0 5.13541 0 9C0 12.8668 3.13428 16 7 16C10.8657 16 14 12.8668 14 9C14 5.13541 10.8657 2 7 2ZM7 5.10484C7.65473 5.10484 8.18548 5.6356 8.18548 6.29032C8.18548 6.94505 7.65473 7.47581 7 7.47581C6.34527 7.47581 5.81452 6.94505 5.81452 6.29032C5.81452 5.6356 6.34527 5.10484 7 5.10484ZM8.58064 12.2742C8.58064 12.4612 8.42899 12.6129 8.24194 12.6129H5.75806C5.57101 12.6129 5.41935 12.4612 5.41935 12.2742V11.5968C5.41935 11.4097 5.57101 11.2581 5.75806 11.2581H6.09677V9.45161H5.75806C5.57101 9.45161 5.41935 9.29996 5.41935 9.1129V8.43548C5.41935 8.24843 5.57101 8.09677 5.75806 8.09677H7.56452C7.75157 8.09677 7.90323 8.24843 7.90323 8.43548V11.2581H8.24194C8.42899 11.2581 8.58064 11.4097 8.58064 11.5968V12.2742Z" fill="#007DA9"/>
          </svg>

          <!-- message text -->
          <span class="text-[#004B65]">
            Any changes to <strong>Filing Information</strong> will trigger a remapping of the submission template, which may overwrite any previously edited or updated fields. 
            <br> Please <strong>review the mapped values for accuracy</strong>, as these were generated using AI and require verification.
          </span>
        </div>
    </p-message>
  </div>

  <div class="header-content bg-transparent">
      <!-- Sheet Selector and Navigation -->
      <div class="container-actions">
          <div class="left-actions">
            <div class="sheet-selector">
              <!-- Hidden span to track state version changes and force re-render -->
              <span class="hidden" [attr.data-state-version]="stateVersion()"></span>
              <p-select
                #sheetSelector
                [disabled]="loadFailure() !== null"
                [ngModel]="currentSheet"
                [options]="filteredSheets"
                optionLabel="label"
                optionValue="value"
                (onChange)="onSheetChange($event.value)"
                [style]="{'min-width': '400px'}"
                placeholder="Select a form sheet"
                class="sheet-dropdown"
                appendTo="body"
              >
                <!-- Header template - Legend showing status icons -->
                <ng-template pTemplate="header">
                  <div class="dropdown-legend">
                    <span class="legend-item">
                      <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-green-600" viewBox="0 0 24 24"
                        fill="none" stroke="currentColor" stroke-width="2" width="16" height="16"
                        stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="20 6 9 17 4 12" />
                      </svg>
                      <small>Validated</small>
                    </span>
                    <span class="legend-item">
                      <svg xmlns="http://www.w3.org/2000/svg"
                           viewBox="0 0 24 24"
                           fill="none"
                           stroke="currentColor"
                           stroke-width="2"
                           stroke-linecap="round"
                           stroke-linejoin="round"
                           class="w-4 h-4 text-red-500">
                        <line x1="18" y1="6" x2="6" y2="18" />
                        <line x1="6" y1="6" x2="18" y2="18" />
                      </svg>
                      <small>Failed</small>
                    </span>
                    <span class="legend-item">
                      <svg xmlns="http://www.w3.org/2000/svg"
                           viewBox="0 0 24 24"
                           fill="none"
                           stroke="currentColor"
                           stroke-width="2"
                           stroke-linecap="round"
                           stroke-linejoin="round"
                           class="w-4 h-4"
                           width="16" height="16">
                        <path d="M12 20h9" />
                        <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z" />
                      </svg>
                      <small>Edited</small>
                    </span>
                  </div>
                  <div class="px-4">
                    <span class="font-lato font-bold text-[12px] leading-[100%] tracking-[0.02em] uppercase">SHEET</span>
                  </div>
                </ng-template>

                <!-- Selected value template - shows in the dropdown trigger -->
                <ng-template let-selectedOption pTemplate="selectedItem">
                  <div class="selected-sheet" *ngIf="selectedOption">
                    <div class="selected-content">
                      <span class="selected-label" data-testid="selected-sheet-label">{{ selectedOption.label }}<span *ngIf="getCachedHasSuggested(selectedOption.value)" class="text-red-500">*</span></span>
                    </div>
                    <div class="status-indicator" data-testid="selected-sheet-status">
                      <ng-container *ngIf="preValidationComplete(); else selectedStatusLoading">
                        <ng-container [ngSwitch]="getCachedStatus(selectedOption.value)">
                          <!-- Valid status - Green checkmark -->
                          <svg *ngSwitchCase="'valid'"
                               xmlns="http://www.w3.org/2000/svg"
                               class="w-4 h-4"
                               viewBox="0 0 24 24"
                               fill="none"
                               stroke="#22c55e"
                               stroke-width="2"
                               stroke-linecap="round"
                               stroke-linejoin="round"
                               width="16"
                               height="16"
                               title="Valid">
                            <polyline points="20 6 9 17 4 12" />
                          </svg>

                          <!-- Edited status - Gray Pen/Pencil icon -->
                          <svg *ngSwitchCase="'edited'"
                               xmlns="http://www.w3.org/2000/svg"
                               viewBox="0 0 24 24"
                               fill="none"
                               stroke="#6b7280"
                               stroke-width="2"
                               stroke-linecap="round"
                               stroke-linejoin="round"
                               class="w-4 h-4"
                               width="16"
                               height="16"
                               title="Edited">
                            <path d="M12 20h9" />
                            <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z" />
                          </svg>

                          <!-- Invalid status - Red X -->
                          <svg *ngSwitchCase="'invalid'"
                               xmlns="http://www.w3.org/2000/svg"
                               viewBox="0 0 24 24"
                               fill="none"
                               stroke="#ef4444"
                               stroke-width="2"
                               stroke-linecap="round"
                               stroke-linejoin="round"
                               class="w-4 h-4"
                               width="16"
                               height="16"
                               title="Failed">
                            <line x1="18" y1="6" x2="6" y2="18" />
                            <line x1="6" y1="6" x2="18" y2="18" />
                          </svg>

                          <!-- Pending validation - spinner -->
                          <p-skeleton *ngSwitchCase="'empty'"
                             shape="circle" size="16px"></p-skeleton>
                        </ng-container>
                      </ng-container>
                      <ng-template #selectedStatusLoading>
                        <p-skeleton shape="circle" size="16px"></p-skeleton>
                      </ng-template>
                    </div>
                  </div>
                </ng-template>

                <!-- Dropdown items template - shows in the dropdown panel -->
                <ng-template let-option pTemplate="item">
                  <div class="sheet-option">
                    <div class="option-content">
                      <span class="option-label">{{ option.label }}<span *ngIf="getCachedHasSuggested(option.value)" class="text-red-500">*</span></span>
                    </div>
                    <div class="status-indicator">
                      <ng-container *ngIf="preValidationComplete(); else itemStatusLoading">
                        <ng-container [ngSwitch]="getCachedStatus(option.value)">
                          <!-- Valid status - Green checkmark -->
                          <svg *ngSwitchCase="'valid'"
                               xmlns="http://www.w3.org/2000/svg"
                               class="w-4 h-4"
                               viewBox="0 0 24 24"
                               fill="none"
                               stroke="#22c55e"
                               stroke-width="2"
                               stroke-linecap="round"
                               stroke-linejoin="round"
                               width="14"
                               height="14"
                               title="Valid">
                            <polyline points="20 6 9 17 4 12" />
                          </svg>

                          <!-- Edited status - Gray Pen/Pencil icon -->
                          <svg *ngSwitchCase="'edited'"
                               xmlns="http://www.w3.org/2000/svg"
                               viewBox="0 0 24 24"
                               fill="none"
                               stroke="#6b7280"
                               stroke-width="2"
                               stroke-linecap="round"
                               stroke-linejoin="round"
                               class="w-4 h-4"
                               width="14"
                               height="14"
                               title="Edited">
                            <path d="M12 20h9" />
                            <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z" />
                          </svg>

                          <!-- Invalid status - Red X -->
                          <svg *ngSwitchCase="'invalid'"
                               xmlns="http://www.w3.org/2000/svg"
                               viewBox="0 0 24 24"
                               fill="none"
                               stroke="#ef4444"
                               stroke-width="2"
                               stroke-linecap="round"
                               stroke-linejoin="round"
                               class="w-4 h-4"
                               width="14"
                               height="14"
                               title="Failed">
                            <line x1="18" y1="6" x2="6" y2="18" />
                            <line x1="6" y1="6" x2="18" y2="18" />
                          </svg>

                          <!-- Pending validation - spinner -->
                          <p-skeleton *ngSwitchCase="'empty'"
                             shape="circle" size="16px"></p-skeleton>
                        </ng-container>
                      </ng-container>
                      <ng-template #itemStatusLoading>
                        <p-skeleton shape="circle" size="16px"></p-skeleton>
                      </ng-template>
                    </div>
                  </div>
                </ng-template>
              </p-select>
            </div>
          </div>
          <div class="right-actions">
            <!-- Caption for the red "*" in the sheet selector. Gated on the
                 sheet's CAPABILITY to raise a suggested change (see
                 `isSuggestionCapable`), not on whether it currently has one —
                 a legend that blinks with the data is not a legend.

                 This is a DIFFERENT concern from the "*" painted above, in the
                 selector's own `selectedItem`/`item` templates (see
                 `getCachedHasSuggested`): that asterisk is a LIVE-STATE
                 indicator — it answers "does this sheet presently have
                 hasSuggestedChanges?" for the active sheet AND every other
                 sheet in the dropdown, including changes that just arrived
                 from another tab — and has nothing to do with capability.
                 The legend and the selector asterisk are two separate
                 questions (capability vs live state) that happen to share one
                 glyph, so opening the selector on a non-capable sheet can show
                 asterisks next to OTHER sheets with no legend caption visible
                 on screen. PO-confirmed 2026-08-11: this asymmetry is
                 intended, not a bug — do not gate the legend on
                 `getCachedHasSuggested`, and do not gate the selector's "*" on
                 `isSuggestionCapable`. -->
            <p class="text-sm" *ngIf="conversionId() && isSuggestionCapable(currentSheet)">(<span class="text-red-500">*</span>) Optional: Suggestions to refine data</p>
          </div>
        </div>
    </div>

  <!-- Form Sheets -->
  <div class="form-sheets mt-6">
    <!--
      Hydration mount-gate: state persistence is async (IndexedDB), so NO sheet
      component is rendered until `hydrated()` flips true (after
      FilingFormStateService.whenHydrated() resolves). This keeps a sheet's
      on-mount "read form + persist" chain from overwriting real, still-loading
      state with schema defaults. The sheet SELECTOR/chrome above is untouched —
      only the sheet body waits. The loader below is sub-second in practice.
      A failed conversion-wide load (`loadFailure()`) also withholds every sheet
      and shows the failure panel instead — see `sheetBodyFallback`.
    -->
    <div *ngIf="sheetBodyMountable() && !loadFailure() && !sheetLoadFailure(); else sheetBodyFallback" class="sheet-container">
      <!-- Role-0: Filing Prerequisites -->
      <div *ngIf="currentSheet === 'filing-prerequisites'" class="sheet-container">
        <app-role0-000000-filing-prerequisites
          [conversionId]="conversionId()"
          [companyName]="companyName()"
          [auditYear]="auditYear()"
          [conversionStatus]="conversionStatus()"
          [conversionAudit]="conversionAudit()"
          [isOnlyFilingSheet]="filteredSheets.length === 1"
          [lastUsedEngine]="lastUsedEngine()"
          (submitForm)="onRole0Submit($event)">
        </app-role0-000000-filing-prerequisites>
      </div>

      <!-- Role-1: Filing Information (Phase 2 editable surface; hidden in Phase 1) -->
      <div *ngIf="currentSheet === 'filing-info'" class="sheet-container">
        <app-role1-010000-filing-info
          [conversionId]="conversionId()"
          [companyName]="companyName()"
          [auditYear]="auditYear()"
          [conversionStatus]="conversionStatus()"
          [conversionAudit]="conversionAudit()"
          [lastUsedEngine]="lastUsedEngine()"
          (submitForm)="onRole1Submit($event)">
        </app-role1-010000-filing-info>
      </div>

      <!-- Role-2: Scope of Filing -->
      <div *ngIf="currentSheet === 'scope-of-filing'" class="sheet-container">
        <app-role2-020000-scope-of-filing></app-role2-020000-scope-of-filing>
      </div>

      <!-- Role-3: Stock Exchange Disclosure -->
      <div *ngIf="currentSheet === 'stock-exchange'" class="sheet-container">
        <app-role3-110000-stock-exchange></app-role3-110000-stock-exchange>
      </div>

      <!-- Role-4: Directors Report -->
      <div *ngIf="currentSheet === 'directors-report'" class="sheet-container">
        <app-role4-120000-directors-report></app-role4-120000-directors-report>
      </div>

      <!-- Role-5: Statement by Directors -->
      <div *ngIf="currentSheet === 'statement-by-directors'" class="sheet-container">
        <app-role5-120100-statement-by-directors></app-role5-120100-statement-by-directors>
      </div>

      <!-- Role-6: Director Business Review -->
      <div *ngIf="currentSheet === 'director-business-review'" class="sheet-container">
        <app-role6-120200-director-business-review></app-role6-120200-director-business-review>
      </div>

      <!-- Role-7: Auditor's Report -->
      <div *ngIf="currentSheet === 'auditors-report'" class="sheet-container">
        <app-role7-130000-auditors-report></app-role7-130000-auditors-report>
      </div>

      <!-- Role-8: Statement of Financial Position -->
      <div *ngIf="currentSheet === 'statement-of-financial-position'" class="sheet-container">
        <app-role8-210000-statement-of-financial-position></app-role8-210000-statement-of-financial-position>
      </div>

      <!-- Role-9: Sub-classification -->
      <div *ngIf="currentSheet === 'sub-classification'" class="sheet-container">
        <app-role9-210100-sub-classification></app-role9-210100-sub-classification>
      </div>

      <!-- Role-10: Statement of Financial Position (Liquidity) -->
      <div *ngIf="currentSheet === 'statement-of-financial-position-liquidity'" class="sheet-container">
        <app-role10-220000-statement-of-financial-position-liquidity></app-role10-220000-statement-of-financial-position-liquidity>
      </div>

      <!-- Role-11: Sub-classification (Liquidity Order) -->
      <div *ngIf="currentSheet === 'sub-classification-liquidity'" class="sheet-container">
        <app-role11-220100-sub-classification-liquidity></app-role11-220100-sub-classification-liquidity>
      </div>

      <!-- Role-12: Statement of Profit or Loss -->
      <div *ngIf="currentSheet === 'statement-of-profit-or-loss'" class="sheet-container">
        <app-role12-310000-statement-of-profit-or-loss></app-role12-310000-statement-of-profit-or-loss>
      </div>

      <!-- Role-13: Analysis of Profit or Loss -->
      <div *ngIf="currentSheet === 'analysis-of-profit-or-loss'" class="sheet-container">
        <app-role13-310100-analysis-of-profit-or-loss></app-role13-310100-analysis-of-profit-or-loss>
      </div>

      <!-- Role-14: Statement of Profit or Loss (By Nature) -->
      <div *ngIf="currentSheet === 'statement-of-profit-or-loss-by-nature'" class="sheet-container">
        <app-role14-320000-statement-of-profit-or-loss-by-nature></app-role14-320000-statement-of-profit-or-loss-by-nature>
      </div>

      <!-- Role-15b: Analysis of Profit or Loss (By Nature) -->
      <div *ngIf="currentSheet === 'analysis-of-profit-or-loss-by-nature'" class="sheet-container">
        <app-role15-320100-analysis-of-profit-or-loss-by-nature></app-role15-320100-analysis-of-profit-or-loss-by-nature>
      </div>

      <!-- Role-15: Statement of Comprehensive Income -->
      <div *ngIf="currentSheet === 'statement-of-comprehensive-income'" class="sheet-container">
        <app-role15-410000-statement-of-comprehensive-income></app-role15-410000-statement-of-comprehensive-income>
      </div>

      <!-- Role-16: Statement of Comprehensive Income (Before Tax) -->
      <div *ngIf="currentSheet === 'statement-of-comprehensive-income-before-tax'" class="sheet-container">
        <app-role16-420000-statement-of-comprehensive-income-before-tax></app-role16-420000-statement-of-comprehensive-income-before-tax>
      </div>

      <!-- Role-17: Statement of Cash Flows (Direct Method) -->
      <div *ngIf="currentSheet === 'statement-of-cash-flows-direct'" class="sheet-container">
        <app-role17-510000-statement-of-cash-flows-direct></app-role17-510000-statement-of-cash-flows-direct>
      </div>

      <!-- Role-18: Statement of Cash Flows (Indirect Method) -->
      <div *ngIf="currentSheet === 'statement-of-cash-flows-indirect'" class="sheet-container">
        <app-role18-520000-statement-of-cash-flows-indirect></app-role18-520000-statement-of-cash-flows-indirect>
      </div>

      <!-- Role-19: Statement of Changes in Equity -->
      <div *ngIf="currentSheet === 'statement-of-changes-in-equity'" class="sheet-container">
        <app-role19-610000-statement-of-changes-in-equity></app-role19-610000-statement-of-changes-in-equity>
      </div>

      <!-- Role-20: Notes - Corporate Information -->
      <div *ngIf="currentSheet === 'notes-corporate-information'" class="sheet-container">
        <app-role20-710000-notes-corporate-information></app-role20-710000-notes-corporate-information>
      </div>

      <!-- Role-21: Notes - Accounting Policies -->
      <div *ngIf="currentSheet === 'notes-accounting-policies'" class="sheet-container">
        <app-role21-720000-notes-accounting-policies></app-role21-720000-notes-accounting-policies>
      </div>

      <!-- Role-22: Notes - List of Notes -->
      <div *ngIf="currentSheet === 'notes-list-of-notes'" class="sheet-container">
        <app-role22-730000-notes-list-of-notes></app-role22-730000-notes-list-of-notes>
      </div>

      <!-- Role-23: Notes - Issued Capital -->
      <div *ngIf="currentSheet === 'notes-issued-capital'" class="sheet-container">
        <app-role23-740000-notes-issued-capital></app-role23-740000-notes-issued-capital>
      </div>

      <!-- Role-24: Notes - Related Party Transactions -->
      <div *ngIf="currentSheet === 'notes-related-party-transactions'" class="sheet-container">
        <app-role24-750000-notes-related-party-transactions></app-role24-750000-notes-related-party-transactions>
      </div>

      <!-- Add more sheets here as they are created -->
      <!-- <div *ngIf="currentSheet === 'accounting-policies'" class="sheet-container">
        <app-role3-accounting-policies></app-role3-accounting-policies>
      </div> -->
    </div>

    <!--
      Hydration loader: shown while the conversion's IndexedDB state hydrates,
      before any sheet component is allowed to mount.

      Uses `<app-sheet-loader>` — the SAME component the 26 sheets show for
      their own schema load — because the two are consecutive waits on one
      entry and the P.O. requires a single loader look. This used to be a
      four-bar `<p-skeleton>` stack captioned "Loading filing data…", so
      entering a conversion could show a skeleton, swap to a spinner, and only
      then render: two different loaders for what the preparer experiences as
      one load.

      It was easy to miss because the swap was usually too fast to see. The
      last-tab-out liveness probe made it visible: on a fresh load carrying
      unsaved edits with no sibling to answer, hydration now waits out
      `CrossTabSyncService.LIVENESS_PROBE_TIMEOUT_MS` before resolving, so this
      loader holds the screen for about a second. The divergence was always
      there — the probe only gave it time to be seen.
    -->
    <ng-template #hydratingLoader>
      <div class="sheet-container">
        <app-sheet-loader [visible]="true" />
      </div>
    </ng-template>

    <!--
      Failed conversion-wide load (any class except PERM/AUTH): show the
      failure panel instead of a sheet. No sheet mounts, so nothing can be
      edited, submitted or persisted. See FilingFormContainerComponent.loadFailure.
    -->
    <ng-template #sheetBodyFallback>
      <div *ngIf="loadFailure() as failedLoad; else sheetFailureOrLoader" class="sheet-container">
        <app-filing-load-failure-panel
          [summary]="failedLoad.summary"
          [retryEnabled]="runtimeConfig.filingLoadRetryEnabled()"
          (retry)="retryLoad()" />
      </div>
    </ng-template>

    <!--
      ONE sheet failed to load (its schema or a support file was missing or
      unreadable, or building it threw) while the conversion itself loaded fine.
      Same inline panel as above, but it replaces only THIS sheet's body: the
      sheet selector stays enabled so the user can open any other sheet, and
      `retrySheetLoad` remounts just this one. Flag off = blank area + the
      original toast only; flag on = the toast's summary plus Retry.
    -->
    <ng-template #sheetFailureOrLoader>
      <div *ngIf="sheetLoadFailure() as failedSheet; else hydratingLoader" class="sheet-container">
        <app-filing-load-failure-panel
          [summary]="failedSheet.summary"
          [retryEnabled]="runtimeConfig.filingLoadRetryEnabled()"
          (retry)="retrySheetLoad()" />
      </div>
    </ng-template>
  </div>

  <!-- Navigation blocking dialog -->
  <p-dialog
    [modal]="true"
    [(visible)]="isNavigationBlockDialogOpen"
    (onHide)="toggleNavigationBlockDialog(false)"
  >
    <ng-template #headless>
      <div class="min-h-[270px] xlplus:min-h-[300px] w-[500px] xlplus:w-[480px] p-[28px] rounded-2xl bg-white">
        <div>
          <h3 class="font-inter font-semibold text-[22px] xlplus:text-2xl">
            Submit Changes to Continue
          </h3>
        </div>
        <div class="mt-[24px]">
          <div class="text-sm xlplus:text-base">
            <div class="flex flex-col gap-4 mt-[24px]">
              <div class="flex flex-row gap-2 2xl:gap-[20px]">
                <div>
                  This sheet has been modified. Please submit this sheet first before proceeding to other sheets.
                </div>
              </div>
            </div>
            <div class="flex flex-col gap-4 mt-[24px]">
              <div class="flex flex-row gap-3 2xl:gap-[20px]">
                <div>
                  Submitting will regenerate the template and <strong>overwrite any changes</strong> made in other sheets.
                </div>
              </div>
            </div>
            <div class="flex gap-3 justify-end mt-[28px]">
              <p-button
                label="Close"
                variant="outlined"
                styleClass="!w-[80px] xlplus:!w-[100px] !border-taxpod-blue !text-taxpod-blue !border-[2px] !text-sm xlplus:!text-base !min-w-[89px] hover:!bg-[#E0F2FE]"
                (onClick)="onNavigationBlockClose()"
              >
              </p-button>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </p-dialog>

  <!--
    Cross-tab Filing Information block. Shown in every OTHER tab of this
    conversion while Filing Information has unsubmitted changes somewhere.

    Deliberately button-less and non-dismissible (P.O. ruling 2026-08-21): the
    only two ways out are the origin tab reverting its changes (the predicate
    turns false and this closes itself) or submitting them (the conversionReset
    broadcast navigates this tab to the XBRL Files listing). `[visible]` is
    hard-coded true because the `@if` below already IS the visibility binding —
    the predicate is a `computed` with no setter, and that is the point: nothing
    else may close it.

    The `@if` wrapper is load-bearing, not cosmetic (2026-08-21). PrimeNG's
    `Dialog` renders its modal mask the moment `visible` turns true, but only
    tears the mask down from `onAnimationEnd({toState:'void'})` — the END of the
    inner container's LEAVE animation. Flip `visible` back to false before that
    container's enter animation has run and there is no `void` transition to
    end, so `maskVisible` stays true forever: an opaque, page-blocking backdrop
    with no dialog inside it. `ngOnDestroy` does not rescue it either — it
    cleans up only `if (this.container)`, and `container` is assigned in
    `onAnimationStart('visible')`. Destroying the whole `<p-dialog>` takes its
    mask with it, which makes the teardown unconditional.
  -->
  @if (isCrossTabFilingInfoBlockOpen()) {
  <p-dialog
    [modal]="true"
    [visible]="true"
    [closable]="false"
    [dismissableMask]="false"
    [closeOnEscape]="false"
  >
    <ng-template #headless>
      <div class="min-h-[270px] xlplus:min-h-[300px] w-[500px] xlplus:w-[480px] p-[28px] rounded-2xl bg-white">
        <div>
          <h3 class="font-inter font-semibold text-[22px] xlplus:text-2xl">
            Submit Filing Info to Continue
          </h3>
        </div>
        <div class="mt-[24px]">
          <div class="text-sm xlplus:text-base">
            <div class="flex flex-col gap-4 mt-[24px]">
              <div class="flex flex-row gap-2 2xl:gap-[20px]">
                <div>
                  You have unsubmitted changes in Filing Information sheet. Please return to that tab and submit the sheet, or undo your changes to continue here.
                </div>
              </div>
            </div>
            <div class="flex flex-col gap-4 mt-[24px]">
              <div class="flex flex-row gap-3 2xl:gap-[20px]">
                <div>
                  Submitting will regenerate the template and <strong>overwrite any changes</strong> made in other sheets. This tab will move to the XBRL File page automatically.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </p-dialog>
  }

  <!-- Leave page confirmation dialog (route deactivation guard) -->
  <p-dialog
    [modal]="true"
    [(visible)]="isLeavePageDialogOpen"
    (onHide)="onLeavePageStay()"
  >
    <ng-template #headless>
      <div class="w-[500px] xlplus:w-[480px] p-[28px] rounded-2xl bg-white">
        <div>
          <h3 class="font-inter font-semibold text-[22px] xlplus:text-2xl">
            Leaving this page?
          </h3>
        </div>
        <div class="mt-[24px]">
          <div class="text-sm xlplus:text-base">
            <div class="flex flex-col gap-4 mt-[24px]">
              <div>
                You have unsaved changes. If you leave now, your changes will be lost.
              </div>
            </div>
            <div class="flex gap-3 justify-end mt-[28px]">
              <p-button
                label="Stay on this page"
                variant="outlined"
                styleClass="!border-taxpod-blue !text-taxpod-blue !border-[2px] !text-sm xlplus:!text-base !min-w-[89px] hover:!bg-[#E0F2FE]"
                (onClick)="onLeavePageStay()"
              >
              </p-button>
              <p-button
                label="Continue without saving"
                styleClass="!bg-taxpod-blue !border-transparent !text-sm xlplus:!text-base !min-w-[89px]"
                (onClick)="onLeavePageContinue()"
              >
              </p-button>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </p-dialog>
</div>
<interactive-toast [key]="'process_mbrs_data'"></interactive-toast>